import type { LinkProps } from '@mui/material/Link';

import { forwardRef } from 'react';

import { CONFIG } from 'src/global-config';
import { Image } from '../image';

// ----------------------------------------------------------------------

export type LogoProps = LinkProps & {
  isSingle?: boolean;
  disabled?: boolean;
  height?: string | number;
  onClick?: () => void;
};

export const Logo = forwardRef<HTMLAnchorElement, LogoProps>((props, ref) => (
  <Image
    onClick={props.onClick}
    style={{
      width: 'auto',
      height: props?.height ?? '40px',
      cursor: props.onClick != null ? 'pointer' : 'inherit',
    }}
    src={
      props.isSingle
        ? `${CONFIG.assetsDir}/logo/logo-single.png`
        : `${CONFIG.assetsDir}/logo/logo-full.png`
    }
    alt="Single Logo"
  />
));
